import { Moon, Sun, Monitor } from 'lucide-react';
import { useThemeStore, type Theme } from '@/lib/theme-store';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/cn';

const OPTIONS: { value: Theme; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
  { value: 'light', label: 'Claro', icon: Sun },
  { value: 'dark', label: 'Oscuro', icon: Moon },
  { value: 'system', label: 'Sistema', icon: Monitor },
];

/**
 * Toggle de tema. 3 opciones: light | dark | system.
 * Persiste en localStorage (vía theme-store).
 */
export function ThemeToggle() {
  const preference = useThemeStore((s) => s.preference);
  const setPreference = useThemeStore((s) => s.setPreference);

  return (
    <div
      role="group"
      aria-label="Tema"
      className="flex items-center gap-1 rounded-md border border-border bg-bg-elevated p-0.5"
    >
      {OPTIONS.map((opt) => {
        const Icon = opt.icon;
        const active = preference === opt.value;
        return (
          <Button
            key={opt.value}
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => setPreference(opt.value)}
            aria-pressed={active}
            aria-label={opt.label}
            className={cn(
              'h-7 w-7 p-0',
              active && 'bg-primary/15 text-primary hover:bg-primary/20',
            )}
            data-testid={`theme-toggle-${opt.value}`}
          >
            <Icon className="h-4 w-4" />
          </Button>
        );
      })}
    </div>
  );
}